import { useRouter, useSearchParams } from 'next/navigation'
import { env } from 'utils/envManager'

import { useSizes } from '../../../../contexts/SizesProvider/SizesProvider'
import type { Size } from '../../../../types/FullProduct'

interface UseSizeItemClickProps {
	isUnselectable: boolean
	withSheet: boolean
}

export function useSizeItemClick({
	isUnselectable,
	withSheet,
}: UseSizeItemClickProps): (size: Size) => void {
	const router = useRouter()
	const params = useSearchParams()
	const { select, isSheetOpen, openSheet, setHasErrorMessage } = useSizes()

	const handleUnselectableSize = (): void => {
		select(undefined)
	}

	const handleNotAvailable = (_size: Size): void => {
		// TODO: Handle back in stock
	}

	const handleAvailable = (size: Size): void => {
		select(size)
		setHasErrorMessage(false)

		if (size.relatedProductUrl) {
			const productUrl = new URL(
				size.relatedProductUrl,
				env.NEXT_PUBLIC_SITE_BASE_URL
			)

			const newParams = new URLSearchParams(Array.from(params.entries()))

			newParams.set('s', size.id)
			productUrl.search = newParams.toString()

			router.push(productUrl.href)
		}

		if (withSheet) {
			openSheet(!isSheetOpen)
		}
	}

	return (size: Size): void => {
		if (isUnselectable) {
			handleUnselectableSize()
		} else if (!size.available) {
			handleNotAvailable(size)
		} else {
			handleAvailable(size)
		}
	}
}
